// Environment-aware file-server origin for custom-page media.
//
// Custom-page renderers build some media URLs on the client (e.g. banner
// videos, which the backend doesn't enrich for custom pages). These bases were
// previously hardcoded — mostly to the STAGING host — so production custom
// pages pulled media from the slower, cold-cached staging box (e.g. a prod
// banner video served from file-server.hertex-staging.net and crawling).
//
// Derive the origin from the host instead: prod on prod, staging on staging.
// localhost maps to staging because local dev runs against the staging backend
// and its data, so the stored media lives on staging.
export const getFileServerBase = (): string => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const useStaging =
    host.includes('staging') || host === 'localhost' || host === '127.0.0.1';
  return useStaging
    ? 'https://file-server.hertex-staging.net'
    : 'https://file-server.hertex.co.za';
};
